/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_FB_BOT} from '../../constans';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';
import queryString from 'query-string';
import {REPORT_STAFF_REQUEST, REPORT_STAFF_SUCCESS, REPORT_STAFF_FAILURE} from "../../types";

const ReportStaffAction = (params = [], page = 1, limit = 10, sort = "-created_at") => ({

    [RSAA]: {
        endpoint: () => {
            params.page = page;
            params.limit = limit;
            params.sort = sort;
            let queryParam = queryString.stringify(params);

            return `${SERVER_API_FB_BOT}/api/group-report?${queryParam}`
        },
        method: 'GET',
        headers: (headers()),
        types: [
            REPORT_STAFF_REQUEST,
            {
                type: REPORT_STAFF_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": REPORT_STAFF_SUCCESS,
                        "data": data,
                    }
                },
            },
            {
                type: REPORT_STAFF_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": REPORT_STAFF_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }
});

export {ReportStaffAction}